module.exports = __webpack_public_path__ + "img/3. Cost Approval_0.66553192.jpg";